import { useTranslation } from "react-i18next";
import { PickupDay } from "@/types/pickupDay";
import clsx from "clsx";
import { HelpTooltip } from "@/components/ui/customs/help-tooltip";

type Day = {
  key: number;
  day: PickupDay;
};

export const DAYS: Day[] = [
  { key: 0, day: "MONDAY" },
  { key: 1, day: "TUESDAY" },
  { key: 2, day: "WEDNESDAY" },
  { key: 3, day: "THURSDAY" },
  { key: 4, day: "FRIDAY" },
];

type DaysPickerProps = {
  selectedDays: number[];
  onToggleDay: (dayIndex: number) => void;
};

export const DaysPicker = ({ selectedDays, onToggleDay }: DaysPickerProps) => {
  const { t } = useTranslation(["boClients", "enums"]);
  return (
    <div className="flex flex-col gap-2">
      <HelpTooltip content={t("pickUpLocationDaysPicker.help")}>
        <p className="text-md font-semibold">{t("pickUpLocationDaysPicker.title")}</p>
      </HelpTooltip>
      <div className="flex flex-row gap-3">
        {DAYS.map((day) => {
          const isSelected = selectedDays.includes(day.key);
          return (
            <div
              key={day.key}
              className={clsx(
                "flex h-8 w-8 cursor-pointer flex-row items-center justify-center gap-2 rounded-full bg-gray-100 p-4 text-sm font-semibold",
                {
                  "bg-blue-600!": isSelected,
                  "border-blue-600": isSelected,
                  "text-white": isSelected,
                },
              )}
              onClick={() => onToggleDay(day.key)}
            >
              {t(`enums:pickupDayInitial.${day.day}`)}
            </div>
          );
        })}
      </div>
    </div>
  );
};
